import * as React from "react";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../react-core/Html/PartLoading";
import { Alert } from "../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ClientRecordAction } from "../../ClientRecord/Action/ClientRecordAction";
import { ClientRecordTab } from "../../ClientRecord/Resource/Contents";
import { ClientRecordStore } from "../../ClientRecord/Store/Variable";
import { WrapperSelectionContents } from "../../NewBusinessWizard/Resource/Contents";
import { PersonalDetail } from "./../../../../../../Wrap/Models/Models/Customer/PersonalDetail";

interface INewClientAlertMessageProps {}

interface INewClientAlertMessageState {
    personalDetail: PersonalDetail;
    isLoading: boolean;
    showAlertBox: boolean;
}

export class NewClientAlertMessage extends FormComponent<INewClientAlertMessageProps, INewClientAlertMessageState> {
    constructor(props: any) {
        super(props);
        const data = ClientRecordStore.getData();
        this.state = {
            personalDetail: data ? data[ClientRecordTab.PersonalDetail] : null,
            isLoading: false,
            showAlertBox: this.isFromAddClient(),
        };
        this.subscribeToStore(ClientRecordStore, () => this.onClientRecordStoreChange());
    }

    public componentDidMount() {
        const isAddClient = this.isFromAddClient();
        const clientId = getQueryParameters()["customerid"];
        if (isAddClient) {
            ClientRecordAction.getPersonalDetail(clientId);
        }
    }

    private isFromAddClient(): boolean {
        return getQueryParameters()["isnewclient"] === "true";
    }

    private onClientRecordStoreChange() {
        const data = ClientRecordStore.getData();
        this.setState({ isLoading: false, personalDetail: data[ClientRecordTab.PersonalDetail] });
    }

    render() {
        if (this.state.isLoading) {return <PartLoading isLoading={true} />;}
        return (
            <>
                {this.state.personalDetail && this.state.showAlertBox && (
                    <div className="mb-28">
                        <Alert
                            alertType={AlertType.Notification}
                            message={WrapperSelectionContents.clientNameMessage(
                                this.state.personalDetail.GivenName,
                                this.state.personalDetail.MiddleName,
                                this.state.personalDetail.FamilyName
                            )}
                            onAlertClose={() => this.onAlertBoxClose()}
                        />
                    </div>
                )}
            </>
        );
    }

    private onAlertBoxClose() {
        this.setState({ showAlertBox: false });
    }
}
